import { GUID_REGEX } from "./consts";

/** Pulls every well-formed GUID out of pasted/typed text, one per line or otherwise. */
export const extractGuids = (text: string): string[] => text.match(GUID_REGEX) ?? [];
